import { createContext } from "react";

/** True inside the workspace Layout (Layout provides it). */
export const InShellContext = createContext(false);
